import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-form-has-errors',
  templateUrl: './form-has-errors.component.html',
  styleUrls: ['./form-has-errors.component.scss']
})
export class FormHasErrorsComponent implements OnInit {
  @Input() showMessage$: Subject<any>;
  @Input() form: UntypedFormGroup;
  showMessage: boolean;

  constructor() { }

  ngOnInit(): void {
    if (this.form) {
      this.form.valueChanges.pipe(untilDestroyed(this)).subscribe({
        next: (data) => {
          this.showMessage = false;
        }
      });
    }
    if (this.showMessage$) {
      this.showMessage$.pipe(untilDestroyed(this)).subscribe({
        next: (data) => {
          this.showMessage = true;
        }
      })
    }
  }

}
